import { DateTimeStr } from '@mi-front/core';
export enum ScreenbugEnum {
  'ScreenBugLabel.SCREEN_BUG_COLORED' = 'COLORED',
  'ScreenBugLabel.BACKGROUND' = 'BACKGROUND',
  'ScreenBugLabel.SCREEN_BUG_GRAYSCALE_TRANSPARENT' = 'TRANSPARENT',
}

export interface ScreenbugResponseType {
  screen_bug: string;
  from: DateTimeStr;
  to: DateTimeStr;
}
